import { css, html } from 'react-strict-dom';
import { spacing } from 'src/constants/spacing.css';

import { Text } from '../../../components';
import { Style } from '../../../constants';
import { LEGEND_STATES, STATE_VISUALS } from '../status';

export default function UptimeLegend() {
  return (
    <html.div style={[Style.row, Style.wrap, styles.legend]}>
      {LEGEND_STATES.map((state) => (
        <html.div
          key={state}
          style={[Style.row, Style.alignCenter, styles.item]}
        >
          <html.span
            style={[
              styles.swatch,
              styles.swatchColor(STATE_VISUALS[state].foreground),
            ]}
            aria-hidden
          />
          <Text typeface="caption.medium" color="neutral60">
            {STATE_VISUALS[state].label}
          </Text>
        </html.div>
      ))}
    </html.div>
  );
}

const styles = css.create({
  legend: {
    gap: `calc(${spacing.unit} * 1.5)`,
  },
  item: {
    gap: `calc(${spacing.unit} * 0.5)`,
  },
  swatch: {
    width: 10,
    height: 10,
    borderRadius: 999,
  },
  swatchColor: (value: string) => ({
    backgroundColor: value,
  }),
});
